import { AfterViewChecked, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Feedback, FeedbackParameter } from "feedback-api";
import { CommonService } from "../common.service";

@Component({
  selector: "app-feedback",
  templateUrl: "./feedback.component.html",
  styleUrls: ["./feedback.component.css"],
})
export class FeedbackComponent implements OnInit, AfterViewChecked {
  error = "no_error";

  feedbackForm: FormGroup;

  form: FormGroup;
  feedback: Feedback = {};

  //lists
  ratingList = null;
  rigoreRatingList = null;
  qualitaRatingList = null;
  professionalitaRatingList = null;
  sicurezzaRatingList = null;
  ordineRatingList = null;

  token = "";

  constructor(
    private commonService: CommonService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngAfterViewChecked(): void {
    this.ratingList = Object.values(this.ratingList);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params["token"];
    });

    if (this.token !== undefined && this.token !== null) {
      this.commonService
        .getFeedbackService()
        .feedbackFeedbackTokenGet(this.token)
        .subscribe(
          (res) => {
            console.log("token validated");
          },
          (error) => {
            console.log("token not valid");
            this.router.navigate(["feedback-errore"]);
          }
        );
    } else {
      this.router.navigate(["feedback-errore"]);
    }
    this.loadlists();
    this.createForm();
    setTimeout(() => this.createForm(), 700);
  }

  createForm() {
    //form

    // let groupRigore = {};

    // for (let i of this.rigoreRatingList) {
    //   groupRigore[i.code] = this.fb.control(false);
    // }

    // console.log(groupRigore);

    // let groupQualita = {};

    // for (let i of this.qualitaRatingList) {
    //   groupQualita[i.code] = this.fb.control(false);
    // }

    // let groupProf = {};

    // for (let i of this.professionalitaRatingList) {
    //   groupProf[i.code] = this.fb.control(false);
    // }

    // let groupSicurezza = {};

    // for (let i of this.sicurezzaRatingList) {
    //   groupSicurezza[i.code] = this.fb.control(false);
    // }

    // let groupOrdine = {};

    // for (let i of this.ordineRatingList) {
    //   groupOrdine[i.code] = this.fb.control(false);
    // }

    // this.feedbackForm = this.fb.group({
    //   rigore: this.fb.group({ groupRigore }),
    //   qualita: this.fb.group(groupQualita),
    //   professionalita: this.fb.group(groupProf),
    //   sicurezza: this.fb.group(groupSicurezza),
    //   ordine: this.fb.group(groupOrdine),
    // });

    // console.log("creo form");
    // console.log(this.feedbackForm);

    // this.form = this.fb.group({
    //   'rigore': this.fb.group({
    //     MRCEA: false,
    //     MRTEA: false,
    //   }),
    // });

    this.feedbackForm = this.fb.group({
      RATING_RIGORE: this.fb.group({
        MRCEA: false,
        MRTEA: false,
        MAPCOV: false,
        MRLPL: false,
        MRARS: false,
      }),
      RATING_QUALITA: this.fb.group({
        SCOSE: false,
        SQOFE: false,
        SQDMU: false,
        SQDSU: false,
        SQDM: false,
      }),
      RATING_PROFESSIONALITA: this.fb.group({
        IGDC: false,
        IGP: false,
        IGS: false,
        IRCC: false,
        IRCP: false,
      }),
      RATING_SICUREZZA: this.fb.group({
        IGDS: false,
        IGPS: false,
        IGSS: false,
        IRPCS: false,
        IRCPS: false,
      }),
      RATING_ORDINE_PULIZIA: this.fb.group({
        IOPFC: false,
        IOPPSC: false,
        IOPRC: false,
        IGTR: false,
        IGDR: false,
      }),
      feedbackComment: [],
    });
  }

  loadlists() {
    //load lists

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("RATING_LIST")
      .subscribe(
        (data) => {
          this.ratingList = data.items;
          console.log("RATING_RIGORE: " + JSON.stringify(this.ratingList));
        },
        (error) => {
          this.error = "Impossibile caricare la lista RIGORE_RATING";
          console.log(error);
        }
      );

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("RATING_RIGORE")
      .subscribe(
        (data) => {
          this.rigoreRatingList = data.items;
          console.log(
            "RATING_RIGORE: " + JSON.stringify(this.rigoreRatingList)
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista RIGORE_RATING";
          console.log(error);
        }
      );

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("RATING_QUALITA")
      .subscribe(
        (data) => {
          this.qualitaRatingList = data.items;
          console.log(
            "RATING_QUALITA: " + JSON.stringify(this.qualitaRatingList)
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista RATING_QUALITA";
          console.log(error);
        }
      );

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("RATING_PROFESSIONALITA")
      .subscribe(
        (data) => {
          this.professionalitaRatingList = data.items;
          console.log(
            "RATING_PROFESSIONALITA: " +
              JSON.stringify(this.professionalitaRatingList)
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista RATING_PROFESSIONALITA";
          console.log(error);
        }
      );

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("RATING_SICUREZZA")
      .subscribe(
        (data) => {
          this.sicurezzaRatingList = data.items;
          console.log(
            "RATING_SICUREZZA: " + JSON.stringify(this.sicurezzaRatingList)
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista RATING_SICUREZZA";
          console.log(error);
        }
      );

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("RATING_ORDINE_PULIZIA")
      .subscribe(
        (data) => {
          this.ordineRatingList = data.items;
          console.log(
            "RATING_ORDINE_PULIZIA: " + JSON.stringify(this.ordineRatingList)
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista RATING_ORDINE_PULIZIA";
          console.log(error);
        }
      );
  }

  onSubmit() {
    this.route.queryParams.subscribe((params) => {
      this.feedback["feedbackToken"] = params["token"];
    });
    this.feedback["feedbackComment"] = this.feedbackForm.value.feedbackComment;
    this.feedback["feedbackParameters"] = [];

    for (let j of Object.keys(this.feedbackForm.value)) {
      if (j != "feedbackComment") {
        for (let i of Object.keys(this.feedbackForm.value[j])) {
          let obj: FeedbackParameter = {
            parameterCode: "",
            parentListName: "",
            parameterSelected: null,
          };

          obj["parentListName"] = j;
          obj["parameterCode"] = i;
          obj["parameterSelected"] = this.feedbackForm.value[j][i];
          this.feedback["feedbackParameters"].push(obj);
        }
      }
    }

    // console.log("final feedback");
    // console.log(this.feedback);

    this.commonService
      .getFeedbackService()
      .feedbackPost(this.feedback)
      .subscribe(
        (res) => {
          this.router.navigate(["feedback-ringraziamento"]);
        },
        (error) => {
          if (error.status == 200) {
            console.log("feedback went through");
            this.router.navigate(["feedback-ringraziamento"]);
          }
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 403
          ) {
            console.log("errore");
            console.log(error);
            this.router.navigate(["feedback-errore"]);
          }
        }
      );
  }
}
